import { SessionCache } from './SessionCache';
import { useCache, useCacheDoc } from './useCache';
import { SESSION_TTL_MS, NEVER_CACHE } from './cacheConfig';

export { SessionCache };
export { useCache, useCacheDoc };
export { SESSION_TTL_MS, NEVER_CACHE };

export function clearAllCache(uid) {
  SessionCache.clearAll(uid).catch(() => {});
}
